import {styled} from "@mui/material/styles"

export const Container = styled("div")`
    background-color: red;
    position: absolute;
    z-index: 2;
    color: white;
    right: 0;
    top: 0;
    padding: 0.1rem;
`
